import './culinaryacademylasvegas/style';
import FormStructure from './culinaryacademylasvegas/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js